export const IMPRESSION_MIN_VISIBLE_RATIO = 0.5;
export const IMPRESSION_MIN_VISIBLE_MS = 3000;
export const HOVER_VIEW_MIN_MS = 3000;
export const MODAL_VIEW_MIN_MS = 2000;
